import { render, staticRenderFns } from "./exampleDialog.vue?vue&type=template&id=162a6254&"
import script from "./exampleDialog.vue?vue&type=script&lang=js&"
export * from "./exampleDialog.vue?vue&type=script&lang=js&"
import style0 from "./exampleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports